const fetchPrintHead = async (printheadCode, caseID) => {
    try {

        // Prepare the query parameters
        const queryParams = new URLSearchParams({
            PrintheadCode: printheadCode,
            CaseID: (caseID || '') // Provide a default empty string if caseID is not provided
        });

        const response = await fetch(`${process.env.REACT_APP_PHPSC_BACK_URL}/phpsc-backend/api/v1/printhead?${queryParams}`, {
            method: 'GET',
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            credentials: 'include' // Include cookies
        });

        if (!response.ok) {
         const data = await response.json();
            // Handle expired token
            if (response.status === 403) {
                console.warn('🔒 Token expired or unauthorized. Logging out...');

                // Optional: clear auth token manually
                document.cookie = 'auth-token=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC;';

                // Optional: clear localStorage if needed
                localStorage.removeItem('redirectURL');

                // Force a full reload or redirect to login
                window.location.reload();
                    throw new Error(data.detail);

            }

            // For other errors
           throw new Error(data.detail);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        throw new Error(error);
    }
};

export default fetchPrintHead;
